import { type FC, memo } from 'react';

import { ScWheelPrize, ScWheelPrizeBg, ScWheelPrizeName } from './styled';

interface PrizeCompProps {
  displayTitle: string;
  isLocked: boolean;
  isHighlighted: boolean;
  total: number;
  index: number;
}

export const PrizeComp: FC<PrizeCompProps> = memo(
  ({ displayTitle, isLocked, isHighlighted, total, index }) => (
    <ScWheelPrize index={index} total={total}>
      <ScWheelPrizeBg
        index={index}
        isHighlighted={isHighlighted}
        total={total}
      />
      <ScWheelPrizeName isLocked={isLocked}>{displayTitle}</ScWheelPrizeName>
    </ScWheelPrize>
  )
);
